export default "__VITE_ASSET__jyeNjpNG__"